import {lazy} from 'react';

export const MissionAsync = lazy(() =>
    import('./Mission')
);
